// Iniciales para el monograma: "Banco San Juan" → "SJ", "Naranja X" → "NX".
const bankInitials = (bank: string) => {
  const words = bank.replace(/^banco\s+/i, '').split(/\s+/).filter(Boolean);
  return words.slice(0, 2).map((word) => word[0]).join('').toUpperCase() || '?';
};

export default bankInitials;
